"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.PymtDtls=void 0;const PymtDtls=exports.PymtDtls="Payment Details";